import { RotateCw } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import ToolPage from "./ToolPage";

export default function RotatePDF() {
  const { t, lang } = useLanguage();
  const tk = t.tools.rotate;


  const config = {
    title: tk.title,
    description: tk.description,
    action: tk.action,
    hint: tk.dropHint,
    hintSub: tk.dropHintSub,
    endpoint: "/pdf/rotate",
    accept: ".pdf",
    multiple: false,
    resultType: "download",
    resultFileName: tk.result,
    color: "#6366f1",
    Icon: RotateCw,
    toolKey: "rotate",
    extraFields: ({ values, onChange }) => (
      <div className="space-y-4 p-5 bg-slate-50 rounded-xl border border-slate-200">
        <div>
          <p className="text-sm font-medium text-slate-700 mb-2">{tk.angleLabel}</p>
          <div className="flex gap-2">
            {["90", "180", "270"].map((deg) => (
              <button
                key={deg}
                type="button"
                onClick={() => onChange({ ...values, rotation: deg })}
                data-testid={`rotation-${deg}`}
                className={`flex-1 py-2 rounded-lg border font-medium text-sm transition-all ${
                  (values.rotation || "90") === deg
                    ? "bg-indigo-600 text-white border-indigo-600"
                    : "bg-white text-slate-700 border-slate-200 hover:border-indigo-300"
                }`}
              >
                {deg}°
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-sm font-medium text-slate-700 mb-2">{tk.pagesLabel}</p>
          <div className="space-y-2">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="radio"
                name="rotate_pages_mode"
                value="all"
                checked={(values.pages_mode || "all") === "all"}
                onChange={() => onChange({ ...values, pages_mode: "all", pages_str: "all" })}
                className="w-4 h-4 accent-indigo-600"
                data-testid="rotate-all-pages"
              />
              <span className="text-sm text-slate-700">{tk.allPages}</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="radio"
                name="rotate_pages_mode"
                value="custom"
                checked={(values.pages_mode || "all") === "custom"}
                onChange={() => onChange({ ...values, pages_mode: "custom", pages_str: "" })}
                className="w-4 h-4 accent-indigo-600"
                data-testid="rotate-specific-pages"
              />
              <span className="text-sm text-slate-700">{tk.specificPages}</span>
            </label>
          </div>
          {(values.pages_mode || "all") === "custom" && (
            <input
              type="text"
              value={values.pages_str || ""}
              onChange={(e) => onChange({ ...values, pages_str: e.target.value })}
              placeholder={tk.pagesPlaceholder}
              data-testid="rotate-pages-input"
              className="mt-2 w-full px-4 py-2.5 rounded-lg border border-slate-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
            />
          )}
        </div>
      </div>
    ),
  };

  return <ToolPage config={config} />;
}
